import { Button, Tooltip } from '@mui/material';
import React from 'react';
import { useHotkeys } from 'src/hooks';
import MaterialDesignIconDuck from '~icons/mdi/duck';
import { useLayout } from '#/layouts';

function ChatPanelButton() {
  const [layoutState, layoutActions] = useLayout();

  const toggleChatbar = React.useCallback(() => {
    if (layoutState.utilityPanelOpen) {
      layoutActions.closeUtilityPanel();
    } else {
      layoutActions.openUtilityPanel({ type: 'chat' });
    }
  }, [layoutActions, layoutState.utilityPanelOpen]);

  const commandsHotKey = useHotkeys(
    'shift+alt+e',
    (e) => {
      e.stopPropagation();
      toggleChatbar();
    },
    {
      enableOnContentEditable: true,
      enableOnFormTags: true,
    },
    [toggleChatbar]
  );

  return (
    <Tooltip
      title={`AI Chat (${commandsHotKey.hint})`}
      placement='bottom'
      arrow
    >
      <Button
        variant='outlined'
        size='small'
        className='group hover:animate-shine'
        onClick={toggleChatbar}
        startIcon={
          <MaterialDesignIconDuck className='group-hover:text-amber-300' />
        }
      >
        Chat
      </Button>
    </Tooltip>
  );
}

export default ChatPanelButton;
